var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Http } from "@repo/http";
import { PLATFORM_BASE_URL } from "../const";
import { resolveBaseUrl } from "../utils";
const http = new Http();
http.setDefaultConfig({
    baseURL: resolveBaseUrl(PLATFORM_BASE_URL),
    timeout: 10000,
    getToken: () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (typeof window === "undefined") {
            const { cookies } = yield import("next/headers");
            const cookieStore = yield cookies();
            if (!process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY) {
                return "";
            }
            const token = ((_a = cookieStore.get(process.env.NEXT_PUBLIC_AUTH_TOKEN_KEY)) === null || _a === void 0 ? void 0 : _a.value) || "";
            return token;
        }
    }),
    getLang: () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (typeof window === "undefined") {
            const { cookies } = yield import("next/headers");
            const cookieStore = yield cookies();
            const lang = ((_a = cookieStore.get("locale")) === null || _a === void 0 ? void 0 : _a.value) || "en";
            return lang;
        }
    }),
    log: {
        enable: false,
    },
});
http.addErrorInterceptor((error) => __awaiter(void 0, void 0, void 0, function* () {
    return true;
}));
export const configureHttp = (config) => {
    http.setDefaultConfig({
        baseURL: config.apiBaseUrl,
        cookieName: config.cookieName,
    });
};
export default http;
//# sourceMappingURL=http.js.map